var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgThreeDotHoriz = function SvgThreeDotHoriz(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 4,
    fill: "none",
    viewBox: "0 0 16 4",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#71717A",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M3 2.001a.833.833 0 1 1-1.667 0 .833.833 0 0 1 1.667 0ZM8.833 2.001a.833.833 0 1 1-1.667 0 .833.833 0 0 1 1.667 0ZM14.666 2.001a.833.833 0 1 1-1.666 0 .833.833 0 0 1 1.666 0Z"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgThreeDotHoriz);
export default ForwardRef;